<template>
    <v-container fluid class="dashboard-root">
        <div class="dashboard-shell">
            <h2>Dashboard Funcionarios</h2>
            <!-- FILTROS -->
            <v-card class="pa-3 mb-3 filtros-card" outlined>
                <!-- Filtros principales -->
                <v-row dense align="center">
                    <v-col cols="12" md="2">
                        <v-select v-model="filtros.oid_estado" :items="Lestado" item-text="n_estado" item-value="oid" label="Estado" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete v-model="filtros.oid_grado" :items="Lgrado" item-text="nombre" item-value="oid" label="Grado" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-autocomplete v-model="filtros.oid_unidad" :items="Lunidad" item-text="nombre" item-value="oid" label="Unidad" outlined dense multiple clearable />
                    </v-col>
                    <v-col cols="12" md="2" class="text-right">
                        <v-btn text color="#5e672c" @click="verFiltros = !verFiltros">
                            <v-icon left small>mdi-filter-variant</v-icon> Más filtros 
                        </v-btn>
                    </v-col>
                    <v-col cols="12" md="2" class="text-right">
                        <v-btn color="#e4b510" dark @click="limpiarFiltros">
                            <v-icon left small>mdi-filter-remove</v-icon> Limpiar 
                        </v-btn>
                    </v-col>
                </v-row>
                <!-- Filtros avanzados -->
                <v-expand-transition>
                    <div v-if="verFiltros" class="mt-3">
                        <v-divider class="mb-3"></v-divider>
                        <v-row dense>
                            <!-- <v-col cols="12" md="3">
                                <v-select v-model="filtros.oid_tipo_documento" :items="Catalogo.TipoDocumento" item-text="nombre" item-value="oid" label="Tipo documento" outlined dense multiple clearable />
                            </v-col> -->
                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.oid_genero" :items="Catalogo.Genero" item-text="nombre" item-value="oid" label="Género" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-select v-model="filtros.oid_estado_civil" :items="Catalogo.EstadoCivil" item-text="nombre" item-value="oid" label="Estado civil" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_cargo" :items="Lcargo" item-text="nombre" item-value="oid" label="Cargo" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-autocomplete v-model="filtros.oid_destino" :items="Ldestino" item-text="nombre" item-value="oid" label="Destino" outlined dense multiple clearable />
                            </v-col>
                            <v-col cols="12" md="3">
    <v-select
        v-model="filtros.oid_categoria"
        :items="Lcategoria"
        item-text="nombre"
        item-value="oid"
        label="Categoría CAS"
        outlined
        dense
        multiple
        clearable
    />
</v-col>

<v-col cols="12" md="3">
    <v-select
        v-model="filtros.oid_frontera"
        :items="Lfrontera"
        item-text="nombre"
        item-value="oid"
        label="Frontera"
        outlined
        dense
        multiple
        clearable
    />
</v-col>

<v-col cols="12" md="3">
    <v-select
        v-model="filtros.oid_funciones"
        :items="Lfunciones"
        item-text="nombre"
        item-value="oid"
        label="Funciones"
        outlined
        dense
        multiple
        clearable
    />
</v-col>

<v-col cols="12" md="3">
    <v-select
        v-model="filtros.grado_policial"
        :items="LgradoPolicial"
        item-text="nombre"
        item-value="oid"
        label="Grado policial"
        outlined
        dense
        multiple
        clearable
    />
</v-col>
                        </v-row>
                    </div>
                </v-expand-transition>
            </v-card>

            <!-- KPIS -->
            <v-row dense class="mb-4">
                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-account-group</v-icon>
                        <div class="kpi-label">Total funcionarios</div>
                        <div class="kpi-value">{{ kpis.total }}</div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-check-circle</v-icon>
                        <div class="kpi-label">Activos</div>
                        <div class="kpi-value">{{ kpis.activos }}</div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-close-circle</v-icon>
                        <div class="kpi-label">Inactivos</div>
                        <div class="kpi-value">{{ kpis.inactivos }}</div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-gender-male</v-icon>
                        <div class="kpi-label">Masculino</div>
                        <div class="kpi-value">{{ kpis.masculino }}</div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-gender-female</v-icon>
                        <div class="kpi-label">Femenino</div>
                        <div class="kpi-value">{{ kpis.femenino }}</div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                    <v-card class="kpi-card pa-4 text-center">
                        <v-icon size="44" color="#5e672c">mdi-office-building</v-icon>
                        <div class="kpi-label">Unidades</div>
                        <div class="kpi-value">{{ kpis.unidades }}</div>
                    </v-card>
                </v-col>
            </v-row>

            <!-- GRÁFICOS -->
            <v-row dense>
                <v-col cols="12" md="8">
                    <v-card class="chart-card pa-4">
                        <h3>Funcionarios por estado</h3>
                        <canvas id="chartEstados"></canvas>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card class="chart-card pa-4">
                        <h3>Funcionarios por género</h3>
                        <canvas id="chartGenero"></canvas>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense class="mt-4">
                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Top unidades</h3>
                        <canvas id="chartUnidades"></canvas>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Top grados</h3>
                        <canvas id="chartGrados"></canvas>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense class="mt-4">
                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Top cargos</h3>
                        <canvas id="chartCargos"></canvas>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Top destinos</h3>
                        <canvas id="chartDestinos"></canvas>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense class="mt-4">
                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Funcionarios por ciudad</h3>
                        <canvas id="chartCiudades"></canvas>
                    </v-card>
                </v-col>

                <v-col cols="12" md="6">
                    <v-card class="chart-card pa-4">
                        <h3>Rangos de edad</h3>
                        <canvas id="chartEdad"></canvas>
                    </v-card>
                </v-col>
            </v-row>

            <v-row dense class="mt-4">
    <v-col cols="12" md="6">
        <v-card class="chart-card pa-4">
            <h3>Funcionarios por categoría CAS</h3>
            <canvas id="chartCategoria"></canvas>
        </v-card>
    </v-col>

    <v-col cols="12" md="6">
        <v-card class="chart-card pa-4">
            <h3>Funcionarios por frontera</h3>
            <canvas id="chartFrontera"></canvas>
        </v-card>
    </v-col>
</v-row>

<v-row dense class="mt-4">
    <v-col cols="12" md="6">
        <v-card class="chart-card pa-4">
            <h3>Funcionarios por funciones</h3>
            <canvas id="chartFunciones"></canvas>
        </v-card>
    </v-col>

    <v-col cols="12" md="6">
        <v-card class="chart-card pa-4">
            <h3>Funcionarios por grado policial</h3>
            <canvas id="chartGradoPolicial"></canvas>
        </v-card>
    </v-col>
</v-row>
        </div>
    </v-container>
</template>
  
<script>
import axios from 'axios';
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN
} from '@/utils/catalogo';
import { setEstados } from '@/utils/validators';

import {
    Chart,
    PieController,
    BarController,
    ArcElement,
    BarElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale
} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    PieController,
    BarController,
    ArcElement,
    BarElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    ChartDataLabels
);

export default {
    data() {
        return {
            datos: [], Larea: [], roles: [], Lestado: [],
            LPais: [], LDepto: [], LCiudad: [], Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [],
            Lcategoria: [], Lfrontera: [], Lfunciones: [], LgradoPolicial: [],
            dato: {
                oid: 0,
                password_hash: 'aa',
                nombres: '',
                primero_apellido: '',
                segundo_apellido: '',
                oid_tipo_documento: null,
                documento: '',
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_depto_nacimiento: null,
                oid_ciudad_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_user: null,
                verificado: null,
                activo: null,
                lat: null,
                lng: null,
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
            },
            chartEstados: null,
            chartGenero: null,
            chartUnidades: null,
            chartGrados: null,
            chartCargos: null,
            chartDestinos: null,
            chartCiudades: null,
            chartEdad: null,
            chartCategoria: null,
            chartFrontera: null,
            chartFunciones: null,
            chartGradoPolicial: null,
            verFiltros: false,
            filtros: {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_destino: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            },
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Documento', value: 'documento' },
                { text: 'Nombres', value: 'nombres' },
                { text: 'Primer Apellido', value: 'primero_apellido' },
                { text: 'Segundo Apellido', value: 'segundo_apellido' },
                { text: 'Correo', value: 'correo' },
                // { text: 'Rol', value: 'rol' },
                // { text: 'Área', value: 'area' },
                { text: 'Activo', value: 'activo' },
            ];

            return baseHeaders;
        },
        usernombres() {
            const user = localStorage.getItem('usernombres'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },
        datosFiltrados() {
            let data = this.datos || [];

            data = this.aplicarFiltroMultiple(data, 'oid_estado', this.filtros.oid_estado);
            data = this.aplicarFiltroMultiple(data, 'oid_grado', this.filtros.oid_grado);
            data = this.aplicarFiltroMultiple(data, 'oid_unidad', this.filtros.oid_unidad);
            data = this.aplicarFiltroMultiple(data, 'oid_genero', this.filtros.oid_genero);
            data = this.aplicarFiltroMultiple(data, 'oid_estado_civil', this.filtros.oid_estado_civil);
            data = this.aplicarFiltroMultiple(data, 'oid_cargo', this.filtros.oid_cargo);
            data = this.aplicarFiltroMultiple(data, 'oid_destino', this.filtros.oid_destino);
            data = this.aplicarFiltroMultiple(data, 'oid_categoria', this.filtros.oid_categoria);
            data = this.aplicarFiltroMultiple(data, 'oid_frontera', this.filtros.oid_frontera);
            data = this.aplicarFiltroMultiple(data, 'oid_funciones', this.filtros.oid_funciones);
            data = this.aplicarFiltroMultiple(data, 'grado_policial', this.filtros.grado_policial);

            return data;
        },
        kpis() {
            const data = this.datosFiltrados || [];

            const total = data.length;
            const activos = data.filter(x => x.activo === true || x.activo === 1).length;
            const inactivos = total - activos;

            const masculino = data.filter(x => this.getGeneroNombre(x.oid_genero).toLowerCase().includes('masculino')).length;
            const femenino = data.filter(x => this.getGeneroNombre(x.oid_genero).toLowerCase().includes('femenino')).length;

            const unidades = new Set(
                data.map(x => x.oid_unidad).filter(x => x !== null && x !== undefined)
            ).size;

            return {
                total,
                activos,
                inactivos,
                masculino,
                femenino,
                unidades
            };
        },
    },
    watch: {
        datosFiltrados: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    this.buildCharts();
                });
            }
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.cargarCatalogosLaborales();
        await setDatos();

        this.LPais = getPaises();
        this.LDepto = getDeptos();
        this.LCiudad = getCiudades();

        await this.listar();
        this.$nextTick(() => this.buildCharts());
    },

    methods: {
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil = getOptionsByCodigo('EstadoCivil');
        },

        async cargarCatalogosLaborales() {
            const [g, c, u, d, cas, fb, f, gp ] = await Promise.all([
                axios.get('api/Grados/Listar'),
                axios.get('api/Cargos/Listar'),
                axios.get('api/Unidads/Listar'),
                axios.get('api/Destinos/Listar'),
                axios.get('api/Categoria_cas/Listar'),
                axios.get('api/FonteraBonos/Listar'),
                axios.get('api/Funciones/Listar'),
                axios.get('api/GradoPolicials/Listar')
            ]);

            this.Lgrado = g.data || [];
            this.Lcargo = c.data || [];
            this.Lunidad = u.data || [];
            this.Ldestino = d.data || [];
            this.Lestado = await setEstados();
            this.Lcategoria = cas.data;
            this.Lfrontera = fb.data;
            this.LgradoPolicial = gp.data;
            this.Lfunciones = f.data;
        },

        async listar() {
            try {
                const pageSize = 1000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: {
                            page,
                            pageSize
                        }
                    });

                    const data = response.data.data || [];
                    total = response.data.total || 0;

                    todos = todos.concat(data);
                    page++;
                } while (todos.length < total);

                this.datos = todos;
            } catch (error) {
                console.error(error);
            }
        },

        buildCharts() {
            const data = this.datosFiltrados  || [];

            const estados = this.groupCount(data, 'oid_estado', this.getEstadoN);
            const genero = this.groupCount(data, 'oid_genero', this.getGeneroNombre);
            const unidades = this.groupCount(data, 'oid_unidad', this.getUnidadN, 10);
            const grados = this.groupCount(data, 'oid_grado', this.getGradoN, 10);
            const cargos = this.groupCount(data, 'oid_cargo', this.getCargoN, 10);
            const destinos = this.groupCount(data, 'oid_destino', this.getDestinoN, 10);
            const ciudades = this.groupCount(data, 'oid_ciudad', getCiudadN, 10);
            const edades = this.groupByAge(data);
            const categorias = this.groupCount(data, 'oid_categoria', this.getCategoriaN);
            const fronteras = this.groupCount(data, 'oid_frontera', this.getFronteraN);
            const funciones = this.groupCount(data, 'oid_funciones', this.getFuncionesN);
            const gradosPoliciales = this.groupCount(data, 'grado_policial', this.getGradoPolicialN);

            this.renderBarChart('chartEstados', estados, 'chartEstados');
            this.renderPieChart('chartGenero', genero, 'chartGenero');
            this.renderBarChartHorizontal('chartUnidades', unidades, 'chartUnidades');
            this.renderBarChart('chartGrados', grados, 'chartGrados');
            this.renderBarChartHorizontal('chartCargos', cargos, 'chartCargos');
            this.renderBarChartHorizontal('chartDestinos', destinos, 'chartDestinos');
            this.renderBarChart('chartCiudades', ciudades, 'chartCiudades');
            this.renderBarChart('chartEdad', edades, 'chartEdad');
            this.renderBarChart('chartCategoria', categorias, 'chartCategoria');
            this.renderBarChart('chartFrontera', fronteras, 'chartFrontera');
            this.renderBarChart('chartFunciones', funciones, 'chartFunciones');
            this.renderBarChart('chartGradoPolicial', gradosPoliciales, 'chartGradoPolicial');
        },

        groupCount(items, key, labelFn, limit = null) {
            const map = new Map();

            items.forEach(item => {
                const raw = item[key];
                const label = labelFn(raw) || 'Sin dato';

                map.set(label, (map.get(label) || 0) + 1);
            });

            let entries = [...map.entries()]
                .map(([label, count]) => ({ label, count }))
                .sort((a, b) => b.count - a.count);

            if (limit) entries = entries.slice(0, limit);

            return {
                labels: entries.map(x => x.label),
                values: entries.map(x => x.count),
            };
        },

        groupByAge(items) {
            const map = {
                '18 - 25': 0,
                '26 - 35': 0,
                '36 - 45': 0,
                '46 - 55': 0,
                '56+': 0,
                'Sin dato': 0,
            };

            items.forEach(x => {
                const edad = this.calcularEdad(x.fecha_nacimiento);
                const rango = this.obtenerRangoEdad(edad);
                map[rango] = (map[rango] || 0) + 1;
            });

            return {
                labels: Object.keys(map),
                values: Object.values(map),
            };
        },

        renderPieChart(canvasId, grouped, refName) {
            if (this[refName]) this[refName].destroy();

            const canvas = document.getElementById(canvasId);
            if (!canvas) return;

            this[refName] = new Chart(canvas.getContext('2d'), {
                type: 'pie',
                data: {
                    labels: grouped.labels,
                    datasets: [{
                        data: grouped.values,
                        backgroundColor: this.getColors(grouped.values.length),
                        borderColor: '#ffffff',
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: { position: 'bottom' },
                        datalabels: {
                            color: '#fff',
                            font: { size: 15, weight: 'bold' },
                            formatter: (value, context) => {
                                const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0) || 1;
                                return `${((value / total) * 100).toFixed(1)}%`;
                            }
                        }
                    }
                }
            });
        },

        renderBarChart(canvasId, grouped, refName) {
            if (this[refName]) this[refName].destroy();

            const canvas = document.getElementById(canvasId);
            if (!canvas) return;

            this[refName] = new Chart(canvas.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: grouped.labels,
                    datasets: [{
                        data: grouped.values,
                        backgroundColor: this.getColors(grouped.values.length),
                        borderColor: '#ffffff',
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        datalabels: {
                            anchor: 'end',
                            align: 'top',
                            color: '#303641',
                            font: { size: 10, weight: 'bold' }
                        }
                    },
                    scales: {
                        y: { beginAtZero: true }
                    }
                }
            });
        },

        renderBarChartHorizontal(canvasId, grouped, refName) {
            if (this[refName]) this[refName].destroy();

            const canvas = document.getElementById(canvasId);
            if (!canvas) return;

            this[refName] = new Chart(canvas.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: grouped.labels,
                    datasets: [{
                        data: grouped.values,
                        backgroundColor: this.getColors(grouped.values.length),
                        borderColor: '#ffffff',
                        borderWidth: 1
                    }]
                },
                options: {
                    indexAxis: 'y',
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        datalabels: {
                            anchor: 'end',
                            align: 'right',
                            color: '#303641',
                            font: { size: 10, weight: 'bold' }
                        }
                    },
                    scales: {
                        x: { beginAtZero: true }
                    }
                }
            });
        },

        getColors(length) {
            const palette = ['#5e672c', '#838858', '#c9a538', '#e4b510', '#727b4a', '#384018'];
            return Array.from({ length }, (_, i) => palette[i % palette.length]);
        },

        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return null;

            const fecha = new Date(fechaNacimiento);
            if (isNaN(fecha.getTime())) return null;

            const hoy = new Date();
            let edad = hoy.getFullYear() - fecha.getFullYear();
            const mes = hoy.getMonth() - fecha.getMonth();

            if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
                edad--;
            }

            return edad;
        },

        obtenerRangoEdad(edad) {
            if (edad == null || edad < 0) return 'Sin dato';
            if (edad <= 25) return '18 - 25';
            if (edad <= 35) return '26 - 35';
            if (edad <= 45) return '36 - 45';
            if (edad <= 55) return '46 - 55';
            return '56+';
        },

        getEstadoN(id) {
            const item = (this.Lestado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.n_estado : 'Sin estado';
        },

        getGeneroNombre(id) {
            const item = (this.Catalogo.Genero || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getGradoN(id) {
            const item = (this.Lgrado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getCargoN(id) {
            const item = (this.Lcargo || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getUnidadN(id) {
            const item = (this.Lunidad || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getDestinoN(id) {
            const item = (this.Ldestino || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getCategoriaN(id) {
            const item = (this.Lcategoria || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getFronteraN(id) {
            const item = (this.Lfrontera || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getFuncionesN(id) {
            const item = (this.Lfunciones || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        getGradoPolicialN(id) {
            const item = (this.LgradoPolicial || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },

        aplicarFiltroMultiple(data, campo, valores) {
            if (!valores || valores.length === 0) return data;

            return data.filter(x =>
                valores.map(Number).includes(Number(x[campo]))
            );
        },

        limpiarFiltros() {this.filtros = {
                oid_estado: [],
                oid_grado: [],
                oid_unidad: [],
                oid_genero: [],
                oid_estado_civil: [],
                oid_cargo: [],
                oid_destino: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            };
        },
    },
};
</script> 
<style>
p, h1, h2, h3 {
    font-family: 'Heebo', sans-serif !important;
}

h2 {
    color: #5e672c;
    font-size: 2rem;
    font-weight: 800;
}

h3 {
    color: #5e672c;
    font-size: 1.3rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 16px;
}

.dashboard-root {
    background:
        radial-gradient(circle at top right, rgba(201, 165, 56, 0.12), transparent 26%),
        linear-gradient(180deg, #f7f8f3 0%, #eef0ea 100%);
    padding: 20px;
    min-height: calc(100vh - 80px);
}

.dashboard-shell {
    width: min(calc(100% - 24px), 1500px);
    max-width: 1500px;
    margin: 0 auto;
}

.kpi-card {
    border-radius: 18px !important;
    border: 1px solid rgba(108, 117, 51, 0.14) !important;
    background: linear-gradient(180deg, #ffffff 0%, #f4f5f0 100%) !important;
    box-shadow: 0 12px 28px rgba(59, 71, 33, 0.08);
    min-height: 150px;
}

.kpi-label {
    color: #727b4a;
    font-size: 13px;
    font-weight: 800;
    margin-top: 8px;
    text-transform: uppercase;
}

.kpi-value {
    color: #384018;
    font-size: 30px;
    font-weight: 800;
    margin-top: 6px;
}

.chart-card {
    border-radius: 18px !important;
    border: 1px solid rgba(108, 117, 51, 0.14) !important;
    background: #ffffff !important;
    box-shadow: 0 12px 28px rgba(59, 71, 33, 0.08);
}
.filtros-card {
    border-radius: 14px !important;
    border: 1px solid rgba(108, 117, 51, 0.18) !important;
    background: rgba(255, 255, 255, 0.78) !important;
}
</style>